import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
    loader: false,
};

const slice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setLoader(state, action) {
            state.loader = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    setLoader,
} = slice.actions;
